/**
 * Leva o desconto real para o checkout (Pix 5% e, com upgrade, 15% no kit).
 * O tema só pinta o preço; sem cupom na Shopify o pedido sai cheio.
 */
(function () {
  if (window.__andradeCheckoutDiscountsBound) return;
  window.__andradeCheckoutDiscountsBound = true;

  var PIX_CODE = window.AndradePixDiscountCode || 'ANDRADE-PIX5';
  var UP_CODE = window.AndradeUpgradeDiscountCode || 'up4T8B893VXB5FBG496gr0Na2FTde5K';

  function cartHasUpgrade(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i += 1) {
      var props = cart.items[i].properties || {};
      var origin = String(props['Origem'] || props['Origin'] || '');
      if (/upgrade/i.test(origin)) return true;
    }
    return false;
  }

  function checkoutUrl(cart) {
    var hasUpgrade = cartHasUpgrade(cart);
    if (hasUpgrade && UP_CODE) {
      return (
        '/discount/' +
        encodeURIComponent(UP_CODE) +
        '?redirect=' +
        encodeURIComponent('/checkout?discount=' + encodeURIComponent(UP_CODE))
      );
    }
    return '/checkout';
  }

  function goToCheckout() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        window.location.assign(checkoutUrl(cart));
      })
      .catch(function () {
        window.location.assign('/checkout?discount=' + encodeURIComponent(UP_CODE));
      });
  }

  window.AndradeCheckout = window.AndradeCheckout || {};
  window.AndradeCheckout.go = goToCheckout;
  window.AndradeCheckout.checkoutUrl = checkoutUrl;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var btn = target.closest('[data-andrade-checkout], button[name="checkout"], input[name="checkout"]');
      if (!btn || btn.disabled) return;
      if (document.querySelector('form.cart-form[data-andrade-block-checkout="true"]')) return;

      event.preventDefault();
      event.stopPropagation();
      (window.AndradeCheckout && window.AndradeCheckout.go ? window.AndradeCheckout.go : goToCheckout)();
    },
    true
  );
})();
